
import { Component, Injector, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MiscUtil } from '../../../util/misc.util';

import { DynformControl } from '../../../model/dymform-control';

import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";


import { BtFormRowComponent } from "../../form/bt-form-row/bt-form-row.component";

@Component({
    selector: 'bt-user-change-password',
    imports: [
        LibModulesWolcModule,
        BtFormRowComponent,
    ],
    templateUrl: './bt-user-change-password.component.html',
    styleUrl: './bt-user-change-password.component.scss'
})
export class BtUserChangePasswordComponent {
  bas = inject(BooktechAppService);

  @Input() 
  get user(): any { return this.edit.obj; }
  set user(user: any) {
    if (user == undefined) return;
    // console.log("user.set: ", user);
    this.editObject(user);
  }

  @Output() userChange = new EventEmitter<any>();


  edit:any = {
    visible: false,
    obj: undefined,
   
  }
  
  constructor() {

    if(this.bas.envtest) console.log("BtUserChangePasswordComponent");

  }

  ngOnInit(): void {

  }

  editObject(obj:any) {

    if(this.bas.envtest) console.log("editObject, obj: ", obj);

    let isAdmin = this.bas.aas.isAdmin();

    let controls: DynformControl[] = [];

    controls.push(new DynformControl({ key: 'id' }));
    controls.push(new DynformControl({ 
      key: 'passwordOld', 
      mk: 'web.common.user.passwordOld', 
      type: "password",
      required: !isAdmin,
      show: () => !isAdmin
    }));
    controls.push(new DynformControl({ 
      key: 'passwordNew', 
      mk: 'web.common.user.passwordNew', 
      type: "password" ,
      required: true
    }));
    controls.push(new DynformControl({ 
      key: 'passwordConfirm', 
      mk: 'web.common.user.passwordConfirm', 
      type: "password",
      required: true
    }));




    this.bas.fs.updateFormObj(this.edit, controls, obj);
    // this.edit.visible = true;
  } 

  onChange(event:any) {

  }

  onCancel() {
    // this.edit.visible = false;
    this.edit.obj = undefined;
    this.userChange.next(this.edit.obj);
  }
  onOk() {

    let rv = this.bas.fs.getRawValue(this.edit.form, this.edit.controls);
    if (rv === false) return;

    if (rv.passwordNew != rv.passwordConfirm) {
      // TODO: https://stackoverflow.com/a/67232471
      
      this.bas.ui.error(this.bas.ui.actrans("web.main.js.jp.register.passwordsDoNotMatch"));
      return;
    }

    
    if (this.bas.aas.isAdmin()) delete rv.passwordOld;

    let obj = this.edit.obj;

    let params:any = {
      aType: "appAdmin", 
      action: "changePassword"
    };
    MiscUtil.extend(params, rv);


    if(this.bas.envtest) console.log("onOk, params: ", params);


    this.edit.loading = true;
    this.bas.ws.json(params).then((json) => {
      this.edit.loading = false;
      
      if (json.success) {
        this.bas.ui.success(json.statusDesc); 

        this.userChange.next(this.edit.obj);
        this.edit.obj = undefined;
      }
    });


    
    // this.edit.visible = false;
  }



}
